var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapscanSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    height: 63,
    viewBox: "0 0 62.987 63",
    width: 62.987,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.494,5A31.5,31.5,0,1,0,67.987,36.5,31.425,31.425,0,0,0,36.494,5m0,60.871A29.372,29.372,0,1,1,65.858,36.5,29.425,29.425,0,0,1,36.494,65.871",
    transform: "translate(-5 -5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.557,14H15.945A1.948,1.948,0,0,0,14,15.945v6.612A1.948,1.948,0,0,0,15.945,24.5h6.612A1.948,1.948,0,0,0,24.5,22.557V15.945A2.084,2.084,0,0,0,22.557,14",
    transform: "translate(4.895 4.899)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.557,21H15.945A1.948,1.948,0,0,0,14,22.945v6.612A1.948,1.948,0,0,0,15.945,31.5h6.612A1.948,1.948,0,0,0,24.5,29.557V22.945A2.084,2.084,0,0,0,22.557,21",
    transform: "translate(4.895 12.599)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.557,14H22.945A1.948,1.948,0,0,0,21,15.945v6.612A1.948,1.948,0,0,0,22.945,24.5h6.612A1.948,1.948,0,0,0,31.5,22.557V15.945A1.837,1.837,0,0,0,29.557,14",
    transform: "translate(12.591 4.899)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapscanSvg);
export default __webpack_public_path__ + "static/media/snapscan-svg.b97fe0e0ecf2452d3a8418ad240bf9ef.svg";
export { ForwardRef as ReactComponent };